var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderPlacedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #c2c8d6;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 84.5,
    y1: 85.5,
    x2: 46.7,
    y2: 47.7,
    gradientTransform: "translate(0 132) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ed259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53c28c"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66,91c-14.4,0-26-11.6-26-26s11.6-26,26-26,26,11.6,26,26-11.6,26-26,26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.1,63.6c.3-.3.6-.4,1-.4.4,0,.8.1,1.1.4h.1c0,.1,5,5.3,5,5.3l9.7-10.2c.3-.3.6-.5,1-.5.4,0,.8,0,1.1.3h.1c.3.4.5.7.5,1.1,0,.4,0,.8-.3,1.1h-.1c0,.1-10.8,11.6-10.8,11.6-.3.3-.6.5-1,.5-.4,0-.8-.1-1.1-.4h-.1c0-.1-6.2-6.4-6.2-6.4-.3-.3-.5-.7-.4-1.1,0-.4.2-.8.5-1.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.7,121.2c-.3,0-.6-.1-.9-.3-.8-.5-1.1-1.6-.6-2.4.5-.8,1.5-1.1,2.3-.7,0,0,.1,0,.1.1.8.5,1.1,1.6.6,2.4-.4.6-.9.9-1.5.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.7,127.7c-.2,0-.3,0-.5-.1-1.9-.6-4-1.2-5.9-1.9-.9-.4-1.3-1.4-1-2.3.4-.9,1.4-1.3,2.3-1,1.8.7,3.7,1.3,5.6,1.8.9.3,1.5,1.2,1.2,2.2-.3.8-1,1.3-1.7,1.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.9,130c-1.7,0-3.6-.1-5.4-.2-1-.1-1.7-.9-1.6-1.9.1-1,.9-1.7,1.9-1.6,1.6.1,3.4.2,5.1.2,33.9,0,61.4-27.6,61.4-61.4s.8-1.8,1.8-1.8,1.8.8,1.8,1.8c-.1,35.8-29.3,65-65.1,65Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.7,20.2c-.4,0-.9-.2-1.2-.5-.7-.7-.7-1.8-.1-2.6.7-.7,1.7-.8,2.4-.1h.1c.7.8.7,1.9,0,2.7-.3.4-.7.5-1.2.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.7,14c-.3,0-.7-.1-1-.3-2.7-1.7-5.4-3.3-8.2-4.6-.9-.4-1.3-1.4-.9-2.3.4-.9,1.4-1.3,2.3-.9,3,1.3,5.9,3,8.7,4.8.8.5,1,1.6.5,2.4-.3.7-.8.9-1.4.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1.8,66.8c-1,0-1.8-.8-1.8-1.8C0,29.2,29.2,0,64.9,0s10.8.7,15.9,1.9c.9.2,1.5,1.2,1.3,2.1-.2.9-1.2,1.5-2.1,1.3-4.9-1.2-10-1.8-15.1-1.8C31.1,3.6,3.6,31.1,3.6,65s-.8,1.8-1.7,1.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderPlacedIcon);
export default __webpack_public_path__ + "static/media/orderPlacedIcon.26ced65b0804115d64332d03d7b9a76a.svg";
export { ForwardRef as ReactComponent };